import { ProgressCircle } from 'components/common/util/ProgressCircle'
import React from 'react'

export const ModuleProgressCircle = () => (
  <div className="absolute top-[45%] left-[50%]">
    <ProgressCircle />
  </div>
)
